// 判断文本是否溢出
export function checkEllipsis(elem) {
    let old, now;
    let newNode = elem.cloneNode(true);
    let result = copyStyle(elem)
    newNode.style.width = "auto";
    newNode.style.visibility = "hidden";
    newNode.style.display = "inline-block"
    result.forEach(item => {
      newNode.style[item.name] = item.value
    })
    document.body.appendChild(newNode);
    old = elem.getBoundingClientRect().width
    now = newNode.getBoundingClientRect().width
    if (Math.abs(old - now) > 1) {
      // 溢出了
      newNode.remove()
      return true
    }
    newNode.remove();
    return false
  }

  function copyStyle(elem) {
    let computedStyle;
    const needStyle = ['fontSize', 'fontFamily', 'padding', 'border', 'fontWeight', 'color']
    let result = []
    if (typeof elem.currentStyle != 'undefined') {
    // 兼容IE
      computedStyle = elem.currentStyle;
    } else {
      computedStyle = window.getComputedStyle(elem, null);
    }
    needStyle.forEach(style => {
      result.push({
        name: style,
        value: computedStyle[style]
      })
    })
    return result
  }